import { AfterViewInit, Component, EventEmitter, Input, Output, ChangeDetectionStrategy } from '@angular/core';
import { Policy } from '../../../../../shared/models/info/policy';
import { IfPolicySatisfiedDirective } from '../../../../directives/if-policy-satisfied.directive';
import { ImportIconComponent } from '../../../icons/import-icon/import-icon.component';
import { initFlowbite } from 'flowbite';
import { CloseIconComponent } from '../../../icons/close-icon/close-icon.component';
import { NwNumber } from '../../../../../shared/models/nw-number/nw-number';
import { DownloadIconComponent } from '../../../icons/download-icon/download-icon.component';
import { ExportType } from '../../../lists/nw-number/nw-number-accordion/export-type';
import { AgentActionDirective } from '../../../../directives/agent-action.directive';
import { CloudArrowUpIconComponent } from '../../../icons/cloud-arrow-up-icon/cloud-arrow-up-icon.component';

@Component({
  selector: 'app-export-nw-number-popover',
  imports: [
    IfPolicySatisfiedDirective,
    ImportIconComponent,
    CloseIconComponent,
    DownloadIconComponent,
    AgentActionDirective,
    CloudArrowUpIconComponent,
  ],
  templateUrl: './export-nw-number-popover.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './export-nw-number-popover.scss',
})
export class ExportNwNumberPopover implements AfterViewInit {
  @Input() public nwNumber?: NwNumber;
  @Output() public exportClicked = new EventEmitter<{ nwNumber: NwNumber; exportType: ExportType }>();
  @Output() public publishEventsClicked = new EventEmitter<{ nwNumber: NwNumber }>();

  protected readonly popoverTargetId = `export-nw-number-popover-${crypto.randomUUID()}`;
  protected readonly policy = Policy;
  protected readonly exportType = ExportType;
  protected isOpen = false;

  public ngAfterViewInit(): void {
    initFlowbite();
  }
}
